import * as types from '../constants/claimStatusTypes';

export const getClaimStatus = (status, assisted, lang) => {
  if (status !== types.CLAIM_STATUS_SUBMITTED && assisted) {
    if (lang === 'fr') {
      return types.GET_CLAIM_STATUS_WHEN_ASSISTED_FR[types.CLAIM_STATUS_PROCESSING];
    }
    return types.GET_CLAIM_STATUS_WHEN_ASSISTED[types.CLAIM_STATUS_PROCESSING];
  }
  if (assisted) {
    if (lang === 'fr') {
      return types.GET_CLAIM_STATUS_WHEN_ASSISTED_FR[status];
    }
    return types.GET_CLAIM_STATUS_WHEN_ASSISTED[status];
  }
  if (lang === 'fr') {
    return types.GET_CLAIM_STATUS_FR[status];
  }
  return types.GET_CLAIM_STATUS[status];
};

export const getGWClaimStatus = (status, lang) => {
  if (status === types.CLAIM_STATUS_SUBMITTED) {
    if (lang === 'fr') {
      return types.GET_CLAIM_STATUS_FR[status];
    }
    return types.CLAIM_STATUS_SUBMITTED;
  }
  if (status === types.CLAIM_STATUS_PROCESSING) {
    if (lang === 'fr') {
      return types.GET_CLAIM_STATUS_FR[status];
    }
    return types.CLAIM_STATUS_PROCESSING;
  }
};
